import React from 'react';

import AddLocationIcon from '@mui/icons-material/AddLocation';
import DataObjectIcon from '@mui/icons-material/DataObject';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore, MissionTool } from '../../stores/MissionStore';

// A small reusable component for the toolbar buttons
const ToolButton = observer(({ tool, label, icon }: { tool: MissionTool; label: string; icon: React.ReactNode }) => {
  const isActive = missionPlannerStore.activeTool === tool;
  return (
    <Tooltip title={label} placement='bottom'>
      <IconButton
        variant='plain'
        color='neutral'
        onClick={() => missionPlannerStore.setActiveTool(tool)}
        sx={{
          backgroundColor: isActive ? 'neutral.plainActiveBg' : 'transparent'
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
});

const MissionTools: React.FC = () => {
  const { activeTool } = missionPlannerStore;

  let instructionalText = '';
  if (activeTool === MissionTool.TakeOff) {
    instructionalText = 'Click on the map to place a takeoff point.';
  } else if (activeTool === MissionTool.ReturnToBase) {
    instructionalText = 'Click on the map to place a landing point.';
  } else if (activeTool === MissionTool.AddWaypoint) {
    instructionalText = 'Click on the map to place a waypoint.';
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography level='title-md' sx={{ mb: 1 }}>
        Tools
      </Typography>
      {instructionalText && (
        <Typography level='body-sm' sx={{ mb: 1, color: 'text.secondary' }}>
          {instructionalText}
        </Typography>
      )}
      <Stack direction='row' spacing={1}>
        <ToolButton tool={MissionTool.TakeOff} label='Takeoff' icon={<FlightTakeoffIcon />} />
        <ToolButton tool={MissionTool.AddWaypoint} label='Waypoint' icon={<AddLocationIcon />} />
        <ToolButton tool={MissionTool.AddPattern} label='Pattern' icon={<DataObjectIcon />} />
        <ToolButton tool={MissionTool.ReturnToBase} label='Return' icon={<FlightLandIcon />} />
      </Stack>
    </Box>
  );
};

export default observer(MissionTools);
